import Vue from 'vue'
import Router from 'vue-router'
import { mountHooks } from './routerHook'
import hooks from './hooks'
Vue.use(Router)

const router = new Router({
  routes: [{
    path: '/',
    name: 'index',
    redirect: '/home'
  }, {
    path: '/home',
    name: 'home',
    meta: {
      showTabbar: true
    },
    component: () => import('../views/home/index.vue')
  }, {
    path: '/my',
    name: 'my',
    meta: {
      showTabbar: true,
      title: '关于我们'
    },
    component: () => import('../views/home/my.vue')
  },
  {
    path: '/partsSearch',
    name: 'partsSearch',
    meta: {
      showTabbar: true,
      title: '搜索配件'
    },
    component: () => import('../views/parts/search.vue')
  },
  {
    path: '/shopList',
    name: 'shopList',
    meta: {
      showTabbar: true,
      useWx: true,
      title: '门店列表'
    },
    component: () => import('../views/shop/list.vue')
  },
  {
    path: '/shopDetail/:id',
    name: 'shopDetail',
    meta: {
      showTabbar: true,
      useWx: true,
      title: '门店详情'
    },
    component: () => import('../views/shop/detail.vue')
  },
  {
    path: '/vin/:vin?',
    name: 'vin',
    meta: {
      showTabbar: true,
      title: '搜索VIN'
    },
    component: () => import('../views/vin/index.vue')
  }, {
    path: '/vinHistory',
    name: 'vinHistory',
    meta: {
      title: 'VIN查询记录'
    },
    component: () => import('../views/vin/history.vue')
  }, {
    path: '/carModel',
    name: 'carModel',
    meta: {
      title: '选择车型'
    },
    component: () => import('../views/carModel/carModel.vue')
  },
  {
    path: '/vinSearch/:vin',
    name: 'vinSearch',
    meta: {
      title: '查询结果'
    },
    component: () => import('../views/vin/searchResult.vue')
  },
  {
    path: '/carModel/detail/:id',
    name: 'carModelDetail',
    meta: {
      title: '车型详情'
    },
    component: () => import('../views/carModel/detail.vue')
  },
  {
    path: '/parts/:id',
    name: 'parts',
    meta: {
      title: '配件列表'
    },
    component: () => import('../views/parts/index.vue')
  }, {
    path: '/transmission',
    name: 'transmission',
    meta: {
      title: '变速箱更换'
    },
    component: () => import('../views/parts/transmissionList.vue')
  },
  {
    path: '/partsEasy',
    name: 'partsEasy',
    meta: {
      title: '商品列表'
    },
    component: () => import('../views/parts/easyList.vue')
  },
  {
    path: '/parts/detail/:partId',
    name: 'partsDetail',
    meta: {
      title: '配件详情'
    },
    component: () => import('../views/parts/detail.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录'
    },
    component: () => import('../views/login/index.vue')
  }]
})
mountHooks(router, hooks)

export default router
